import { Box, Card, Checkbox, Tag } from '@nimbus-ds/components';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';

interface OptionsProps {
  updateStock?: boolean;
  notifyClient?: boolean;
  disabled: boolean;
  onUpdateStockChange: (value: boolean) => void;
  onNotifyClientChange: (value: boolean) => void;
}

function Options({
  updateStock = true,
  notifyClient = true,
  disabled,
  onUpdateStockChange,
  onNotifyClientChange,
}: OptionsProps): JSX.Element {
  const t = useTranslationOrders('autoCancel');

  return (
    <Card>
      <Card.Header title={t('optionsTitle')} />
      <Card.Body>
        <Box gap="4" display="flex" flexDirection="column">
          <Checkbox
            label={t('updateStock')}
            checked={updateStock}
            onChange={(e) => onUpdateStockChange(e.target.checked)}
            name="updateStockCheckbox"
            disabled={disabled}
          />

          <Box display="flex" flexDirection="row" gap="2" alignItems="center">
            <Checkbox
              label={t('preNotifyClient')}
              checked={false}
              disabled
              name="preNotifyClientCheckbox"
            />
            <Tag>{t('comingSoonTag')}</Tag>
          </Box>

          <Checkbox
            label={t('notifyClient')}
            checked={notifyClient}
            onChange={(e) => onNotifyClientChange(e.target.checked)}
            name="notifyClientCheckbox"
            disabled={disabled}
          />
        </Box>
      </Card.Body>
    </Card>
  );
}

export default Options;
